import React from 'react';
import CyberBackground from './CyberBackground';
import AIAssistant from './AIAssistant';
import ConnectionStatusBar from './ConnectionStatusBar';
import MainNavigation from './MainNavigation';
import WalletConnectButton from '../common/WalletConnectButton';
import { useUI } from '../../contexts/UIContext';
import { Menu } from 'lucide-react';

const Layout = ({ children }) => {
  const { isMobile, isMobileMenuOpen, toggleMobileMenu } = useUI();

  return (
    <div className="platform-container">
      {/* Cybernetic Background */}
      <CyberBackground />

      {/* AI Assistant Floating Icon */}
      <AIAssistant />

      {/* Connection Status Bar with Menu Button */}
      <ConnectionStatusBar />

      {/* Mobile Menu Button - positioned directly, not in the flow */}
      {isMobile && (
        <div className="mobile-menu-btn" onClick={toggleMobileMenu}>
          <Menu size={20} color="#000" />
        </div>
      )}

      {/* Main Navigation */}
      <MainNavigation />

      {/* Main Content Area */}
      <main className={`content-area ${isMobile ? 'mobile-view' : ''}`}>
        {/* Connect wallet button at the top of the content for both views */}
        <div className="connect-wallet-container">
          <WalletConnectButton />
        </div>
        
        {children}
      </main>
    </div>
  );
};

export default Layout;